// Constants.js

export const CONTROL_TYPE_OPTIONS = [
  "INFORMATION",
  "SUBMISSIONLIST",
  "SUMMARY",
  "RADIO",
  "CHECKBOX",
  "TEXT",
  "RATING",
  "SLIDER",
  "MATHS",
];
